module.exports = __webpack_public_path__ + "static/img/pz.042db74f.webp";